import styled, { css } from 'styled-components'

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['16']};
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadow.marketShopShadow};

    > * {
      padding-left: ${theme.space['16']};
      padding-right: ${theme.space['16']};
    }

    > *:first-child {
      padding-top: ${theme.space['16']};
    }

    > *:last-child {
      padding-bottom: ${theme.space['16']};
    }
  `,
)

export const Orders = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['8']};
    overflow: auto hidden;

    // TODO: use from common styles later
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    > * {
      max-width: 40rem;
    }
  `,
)

export const MainBar = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${theme.space['8']};

    // NOTE: using id selector to reuse component from lib but style it as needed in design
    #search-input {
      height: 4.4rem;
    }
  `,
)

export const Categories = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['8']};
    overflow: auto hidden;

    // TODO: use from common styles later
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
  `,
)
